import { Category, CxEvent, Price, Product } from '@spartacus/core';
import { PageEvent } from '@spartacus/storefront';
import { EcommerceProductDetail, EcommerceProductImpression } from './custom-product-events.model';
import { Params } from "@angular/router";

/**
 * Indicates that a user visited a product detail page.
 */
export class CustomProductDetailsPageEvent extends CxEvent {
  /** event's type */
  static readonly type = 'ProductDetailsPageEvent';
  event: string;
  ecommerce: EcommerceProductDetail;
}


/**
 * Indicates that a user visited a category page.
 */
export class CategoryPageResultsEvent extends PageEvent {
  /** event's type */
  static readonly type = 'CategoryPageResultsEvent';
  categoryCode: string;
  categoryName?: string;
  numberOfResults: number;
}

/**
 * Indicates that the a user visited the search results page,
 * and that the search results have been retrieved.
 */
export class SearchPageResultsEvent extends PageEvent {
  /** event's type */
  static readonly type = 'SearchPageResultsEvent';
  searchTerm: string;
  numberOfResults: number;
}

/**
 * Indicates which products have been displayed,
 * and have been selected.
 */
export class CustomProductImpressionResultsEvent extends CxEvent {
  /** event's type */
  static readonly type = 'ProductImpressionResultsEvent';
  event: string;
  ecommerce: EcommerceProductImpression;
}

export class CustomProductSelectedEvent extends CxEvent {
  /** event's type */
  static readonly type = 'ProductSelectedEvent';
  product: Product;
  activateRouteParams: Params;
}
